import { Box, Heading, Text, Image, VStack } from "@chakra-ui/react";

const DocumentationDetail = ({ title, content }) => {
  return (
    <Box as="section" py={12} px={6} maxW="800px" mx="auto">
      <Heading size="lg" mb={6} color="teal.600" textAlign="center">
        {title}
      </Heading>

      <VStack align="start" spacing={6}>
        {content.map((item, index) => (
          <Box key={index}>
            {item.type === "text" && (
              <Text fontSize="md" lineHeight="tall" color="gray.700">
                {item.value}
              </Text>
            )}
            {item.type === "image" && (
              <Image
                src={item.value}
                alt={`Documentation image ${index}`}
                borderRadius="md"
                boxShadow="md"
                my={4}
              />
            )}
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default DocumentationDetail;
